import { render, staticRenderFns } from "./SignupDialog.vue?vue&type=template&id=bd4df2be&scoped=true"
import script from "./SignupDialog.vue?vue&type=script&lang=js"
export * from "./SignupDialog.vue?vue&type=script&lang=js"
import style0 from "./SignupDialog.vue?vue&type=style&index=0&id=bd4df2be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4df2be",
  null
  
)

export default component.exports